// ---------------------------------------------------------------------------
// Conteúdo da página local /advogado-criminalista-brasilia.
//
// Esta página NÃO é a versão "com cidade" da home. A intenção é outra: quem
// busca "advogado criminalista Brasília" quer alguém que esteja aqui, que
// conheça as varas do TJDFT e que possa ir à delegacia hoje. Por isso o texto
// fala de estrutura judiciária local, e não de atuação em geral.
//
// Cuidado ao editar: só entra aqui o que for verificável. Nada de nome de
// vara, endereço de fórum ou número de plantão sem conferir antes.
// ---------------------------------------------------------------------------

const brasilia = {
  h1: 'Advogado Criminalista em Brasília',
  intro: [
    'A Justiça criminal do Distrito Federal tem uma organização própria. Não há divisão em municípios: o território se reparte em regiões administrativas, e o TJDFT distribui a competência entre circunscrições judiciárias. Na prática, a delegacia que registra a ocorrência e a vara que julga o caso são definidas pela região onde o fato aconteceu.',
    'Para quem precisa de defesa aqui, isso significa que a resposta útil depende de saber para onde ir — e chegar rápido. Atendimento presencial no Distrito Federal, sempre com hora marcada, e deslocamento a delegacias e fóruns do DF nos casos urgentes.',
  ],

  // Estrutura local — apenas o que é verificável e estável.
  estrutura: [
    {
      titulo: 'TJDFT e as circunscrições',
      texto:
        'Os processos criminais de competência estadual tramitam nas varas criminais das circunscrições judiciárias do Distrito Federal, e o segundo grau é julgado pelo próprio TJDFT.',
    },
    {
      titulo: 'Polícia Civil do DF',
      texto:
        'Os inquéritos de competência estadual são conduzidos pela Polícia Civil do Distrito Federal, nas delegacias das regiões administrativas.',
    },
    {
      titulo: 'Justiça Federal',
      texto:
        'Crimes de competência federal correm na Seção Judiciária do Distrito Federal, com investigação a cargo da Polícia Federal, cuja sede nacional fica em Brasília.',
    },
    {
      titulo: 'Juizados e varas especializadas',
      texto:
        'Infrações de menor potencial ofensivo vão aos juizados especiais criminais; os casos da Lei Maria da Penha, aos juizados de violência doméstica e familiar; a execução da pena, à Vara de Execuções Penais.',
    },
    {
      titulo: 'Plantão judiciário',
      texto:
        'Prisões ocorridas em fins de semana e feriados são apresentadas em regime de plantão, o que exige defesa disponível fora do horário comercial.',
    },
    {
      titulo: 'STJ e STF',
      texto:
        'Os tribunais superiores ficam em Brasília. É a razão pela qual a base aqui serve tanto ao cliente do DF quanto ao de qualquer outro estado cujo caso chegue à fase recursal.',
    },
  ],

  faq: [
    {
      pergunta: 'O escritório tem endereço aberto ao público em Brasília?',
      resposta:
        'O atendimento presencial no Distrito Federal é feito sempre com hora marcada, e o local é combinado no agendamento. Não há recepção aberta para atendimento sem agendamento prévio. Para casos urgentes, o deslocamento é feito até a delegacia ou o fórum onde a pessoa estiver.',
    },
    {
      pergunta: 'Atende em todas as regiões administrativas do DF?',
      resposta:
        'Sim. A atuação acompanha a circunscrição judiciária competente, qualquer que seja a região administrativa em que o fato ocorreu, incluindo Entorno quando o caso tramita no Distrito Federal.',
    },
    {
      pergunta: 'Preciso morar em Brasília para contratar?',
      resposta:
        'Não. A atuação é nacional: clientes de outros estados são atendidos por videoconferência, e a presença física em Brasília é justamente o que permite acompanhar de perto os processos que sobem ao STJ e ao STF.',
    },
    {
      pergunta: 'Quanto tempo leva para um advogado chegar à delegacia?',
      resposta:
        'Depende da região administrativa e do horário, mas o deslocamento dentro do Distrito Federal é feito no mesmo dia em situações de flagrante. O primeiro contato por telefone ou WhatsApp já orienta o que fazer enquanto isso.',
    },
  ],
};

export default brasilia;
